export enum EnumGenero {
  MASCULINO = 'MASCULINO',
  FEMININO  = 'FEMININO'
}

export enum EnumParentesco {
  CONJUGE = 1,
  PROGENITOR = 2,
  IRMAO = 3,
  FILHO = 4,
  OUTRO = 5
}

export enum EnumNivelRisco {
  BAIXO = 1,
  MODERADO = 2,
  ALTO = 3,
  CRITICO = 4
}

export enum EnumOcorrenciaCriticidade {
  ALTA = 1,
  MEDIA = 2,
  URGENTE = 3
}

export enum EnumEstadoEquipamento {
  BOM = 1,
  DESTRUIDO = 2,
  INATIVO = 3
}

export enum EnumMarcaCategoria {
  VEICULO = 1,
  ARMA = 2,
  UTENSILIO = 3,
  VIATURA
}

export enum EnumPeriodoCobertura {
  DIURNO  = 'DIURNO',
  NOTURNO = 'NOTURNO',
  HORAS_24 = '24_HORAS'
}

export enum EnumTipoDado {
  STRING  = 'STRING',
  NUMBER  = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  DATE    = 'DATE'
}

export enum EnumTipoOcorrencia {
  INCIDENTE = 1,
  FALHA_EQUIPAMENTO = 2,
  INTRUSAO = 3,
  EMERGENCIA = 4,
  OUTRO = 5
}

export enum GeneroEnum {
  MASCULINO = 1,
  FEMININO = 2
}

export enum EstadoEfetivoEnum {
  ATIVO = 0,
  INATIVO = 1,
  AFASTADO = 2,
  SUSPENSO = 3,
  DE_FOLGA = 4,
  FERIAS = 5
}

export enum ParentescoEnum {
  CONJUGE = 1,
  PROGENITOR = 2,
  IRMAO = 3,
  FILHO = 4,
  OUTRO = 5
}

export enum EnumFiltrosPeriodo{
  ESTES_MES = 1,
  HOJE = 2,
  ESTA_SEMANA = 3,
  ULTIMO_TRIMESTRE = 4,
}

export enum EnumOcorrenciaEstado {
  ABERTA = 1,
  FECHADA = 2,
  EM_PROGRESSO = 3
}

export enum EnumDesfechoOcorrencia {
  RESOLVIDA = 1,
  FALSO_ALARME = 2,
  SEM_ACCAO_NECESSARIA = 3,
  ENCAMINHADA_AUTORIDADES = 4,
}